export const CREATE_TEEN_EVENTS = {
  SELECT_ADD_KID_CHANGE_CARD_THEME: 'select_add_kid_change_card_theme',
  VIEW_ADD_KID_CARD_THEME_MODAL: 'view_add_kid_card_theme_modal',
  SELECT_ADD_KID_NEW_CARD_THEME: 'select_add_kid_new_card_theme',
  VIEW_ADD_KID_NAME_DOB: 'view_add_kid_name_dob',
  SELECT_ADD_KID_NAME_DOB_CONTINUE: 'select_add_kid_name_dob_continue',
  VIEW_ADD_KID_EMAIL_PHONE: 'view_add_kid_email_phone',
  SELECT_ADD_KID_EMAIL_PHONE_CONTINUE: 'select_add_kid_email_phone_continue',
  VIEW_ADD_KID_SUCCESS: 'view_add_kid_success',
} as const;
